export default function getIsOnlySingleIcon(_ref) {
  var children = _ref.children,
    iconBefore = _ref.iconBefore,
    iconAfter = _ref.iconAfter;
  if (children) {
    return false;
  }
  if (iconBefore && !iconAfter) {
    return true;
  }
  if (!iconBefore && iconAfter) {
    return true;
  }
  return false;
}